export default {"src":"/_next/static/media/logout.c3168330.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};